<p-breadcrumb
  [model]="[
    {
      label: 'Tipos de Identificador do Produto',
      routerLink: ['/product-identifier-types']
    },
    {
      label: productIdentifierTypeId() ? 'Editar Tipo' : 'Novo Tipo',
      routerLink: productIdentifierTypeId()
        ? ['/product-identifier-types/update/' + productIdentifierTypeId()]
        : ['/product-identifier-types/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(productIdentifierTypeId()){
        <h5 class="font-bold">Editar Tipo</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Novo Tipo</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-5 items-center">
        @if(productIdentifierTypeId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive" />
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }
        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/product-identifier-types"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="flex flex-wrap xl:flex-nowrap gap-5 mt-5">
    <div class="card space-y-5 w-full">
      <h5 class="font-bold">Informações gerais</h5>
      <div class="w-full">
        <label>Nome *</label>
        <input
          pInputText
          formControlName="name"
          class="w-full"
          placeholder="Informe o nome"
        />
        <app-form-error [control]="formGroup.get('name')" />
        <app-form-server-error [control]="formGroup.get('name')" />
      </div>

      <div class="w-full">
        <label>Descrição</label>
        <input
          pInputText
          formControlName="description"
          class="w-full"
          placeholder="Informe a descrição"
        />
        <app-form-error [control]="formGroup.get('description')" />
        <app-form-server-error [control]="formGroup.get('description')" />
      </div>
    </div>
  </div>

  @if(loading()){
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
  }
</form>
<p-toast />
